import { HttpClient } from '../interceptor';

export class ClassroomManagementApi{
    // 获取教室列表
    static getClassroomList = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/classroomController/getClassroom', param).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }

    // 新增教室
    static insertClassroom = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/classroomController/addClassroom', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 编辑教室
    static updateClassroom = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/classroomController/updateClassroom', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 获取教室时段
    static getClassroomSlotList = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/classroomController/getTimeSlot', param).then(res => {
                if(res.data.status === 200){
                    let result = res.data.content.data;
                    result.forEach((item, index) => {
                        item.selected = false;
                        item.index = index;
                    });
                    resolve(result);
                }
            }).catch(err => console.log(err));
        })
    }

    // 编辑教室时段（更新为课程）
    static editClassroomSlot = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/courseController/updateCourse', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    static initClassroomSlot = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/classroomController/batchAddTimeSlot', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }
}